<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="container card-body table-responsive">
        <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.PROCESOS}">
          <div class="col-sm-6 text-sm-right mb-2">
            <button *hasPermission="{app: constant.PROCESOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModalDesempenio()"><i class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
          </div>
        </div>

        <table class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Caracteristicas</th>
              <th>Importancia</th>
              <th>Desempeño</th>
              <th>Calificación</th>
              <th>Peso</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let desempenioProceso of dataNombreImportancia;let indice=index">
              <td>{{indice+1}}</td>
              <td>{{desempenioProceso.nombreCaracteristica}}</td>
              <td>{{desempenioProceso.nombreImportancia}}</td>
              <td>{{desempenioProceso.nombreDesempenio}}</td>
              <td>{{desempenioProceso.calificacion}} %</td>
              <td>{{desempenioProceso.peso}} %</td>
              <td>{{((desempenioProceso.estado == '1')? 'Activo': 'Inactivo')}}</td>
              <td class="text-center">
                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.PROCESOS}">
                  <button *hasPermission="{app: constant.PROCESOS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="edit(desempenioProceso)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>
                  <button *hasPermission="{ app: constant.PROCESOS, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro"(click)="delete(desempenioProceso.idSprDesempenioProceso)">
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<jw-modal id="delete-desempenio" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

<jw-modal id="{{modalCreaDesempenioProceso}}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{nameApp}}</h3>
        <button type="button" class="btn-close" (click)="closeModalDesempenio();" aria-label="Close"></button>
      </div>

      <div class="modal-body px-5">
        <form action="#" [formGroup]="formDesempenioProceso" class="needs-validation ">

          <input type="hidden" id="idSprDesempenioProceso" formControlName="idSprDesempenioProceso">
          <div class="form-group row mb-2">
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprCaracteristica" class=" form-control-label text-md-right pt-1"><b>Característica:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <select class="form-select col-12" id="idSprCaracteristica" formControlName="idSprCaracteristica" required="true" [ngClass]="{'is-invalid': this.formDesempenioProceso.get('idSprCaracteristica')?.errors && this.formSubmitted,'is-valid': !this.formDesempenioProceso.get('idSprCaracteristica')?.errors,}">
                <option *ngFor="let catCaracteristica of dataCaracteristicas" value={{catCaracteristica.idSprComun}}>
                  {{catCaracteristica.nombre}}
                </option>
              </select>
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formDesempenioProceso.get('idSprCaracteristica')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprImportancia" class=" form-control-label text-md-right pt-1"><b>Importancia:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <select class="form-select col-9"  id="idSprImportancia"formControlName="idSprImportancia" required="true" (ngModelChange)="onSelectImportancia($event)" [ngClass]="{'is-invalid': this.formDesempenioProceso.get('idSprImportancia')?.errors && this.formSubmitted,'is-valid': !this.formDesempenioProceso.get('idSprImportancia')?.errors,}">
                <option *ngFor="let catImportancia of dataImportancia" value={{catImportancia.idSprEspecialUno}}>
                  {{catImportancia.nombre}}
                </option>
              </select>
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formDesempenioProceso.get('idSprImportancia')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>

            <div class="col col-md-2 text-md-right">
              <label for="idSprDesempenio" class=" form-control-label text-md-right pt-1"><b>Desempeño:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <select class="form-select col-12" id="idSprDesempenio" formControlName="idSprDesempenio" required="true"(ngModelChange)="onSelectDesempenio($event)" [ngClass]="{'is-invalid': this.formDesempenioProceso.get('idSprDesempenio')?.errors && this.formSubmitted,'is-valid': !this.formDesempenioProceso.get('idSprDesempenio')?.errors,}">

                <option *ngFor="let catDesempenio of dataDesempenio" value={{catDesempenio.idSprEspecialUno}}>
                  {{catDesempenio.nombre}}
                </option>
              </select>
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formDesempenioProceso.get('idSprDesempenio')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="calificacion" class=" form-control-label text-md-right pt-1"><b>Calificación:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <input  maxlength="50" min="0" max="100" class="form-control" required="true" [readOnly]="true" placeholder="Calificación" style="background-color: #f7f4f4;"formControlName="calificacion" [disabled]="desahabilitarForm" oninput="this.value = this.value.toUpperCase();" value={{calificaciones}}>
              <div class="col text-danger">
              </div>
            </div>
            <div class="col col-md-2 text-md-right ">
              <label for="estado" class="col-form-label text-md-right"><b>Estado:</b></label>
            </div>
            <div class="col-12 col-md-4 ">
              <select class="form-select " id="estado" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formDesempenioProceso.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formDesempenioProceso.get('estado')?.errors,}">
                <option [value]="item.value" *ngFor="let item of selectItems">{{item.label}}
                </option>
              </select>
              <div class="col text-danger">
                <small class="font-italic" *ngIf="this.formDesempenioProceso.get('estado')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="peso" class=" form-control-label text-md-right pt-1"><b>Peso Desempeño:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <input type="number" min="0" max="100" maxlength="3" onkeydown="return false" name="peso" id="peso" placeholder="Solo caracteres Numericos" class="form-control" required autocomplete="off" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="peso" required
                autofocus placeholder="peso" [ngClass]="{'is-invalid': this.formDesempenioProceso.get('peso')?.errors && this.formSubmitted,'is-valid': !this.formDesempenioProceso.get('peso')?.errors, }" [disabled]="desahabilitarForm" [readonly]="desahabilitarForm">
              <small class="invalid-feedback" *ngIf="this.formDesempenioProceso.get('peso')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
            </div>
            <div *ngIf="editPorcentajeTotal" class="col col-md-2 text-md-right">
              <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje restante (%):</b>
              </label>
            </div>
            <div *ngIf="editPorcentajeTotal" class="col-12 col-md-4">
              <input class="form-control" disabled style="background-color: #e9e8e8;" placeholder="{{pesoRestante}} %" />
            </div>

            <div *ngIf="editPorcentaje" class="col col-md-2 text-md-right">
              <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje restante (%):</b>
              </label>
            </div>
            <div *ngIf="editPorcentaje" class="col-12 col-md-4">
              <input class="form-control" disabled style="background-color: #f5f4f4;" placeholder="{{pesoTotalEditado}} %" />
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalDesempenio();">Cerrar</button>
            <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</jw-modal>
